import Vue from 'vue';
import arrowDown from './arrow-down.svg';
import arrowPrev from './arrow-prev.svg';
import arrowNext from './arrow-next.svg';
import bill from './bill.svg';
import chat from './chat.svg';
import check from './check.svg';
import close from './close.svg';
import emails from './emails.svg';
import applicants from './applicants.svg';
import eyeoff from './eyeoff.svg';
import eyeon from './eyeon.svg';
import logout from './logout.svg';
import moon from './moon.svg';
import nodata from './nodata.svg';
import search from './search.svg';
import trainging from './trainging.svg';
import logoDark from './logo-dark.svg';
import users from './users.svg';
import skills from './skills.svg';
import bag from './bag.svg';
import jobsBag from './jobs-bag.svg';
import location from './location.svg';
import clock from './clock.svg';
import file from './file.svg';
import download from './download.svg';
import company from './company.svg';
import government from './government.svg';
import individual from './individual.svg';
import organization from './organization.svg';
import refresh from './refresh.svg';
import f_products from './financial/products.svg';
import f_clients from './financial/clients.svg';
import f_clients2 from './financial/clients2.svg';
import f_orders from './financial/orders.svg';
import f_sales from './financial/sales.svg';
import f_profit from './financial/profit.svg';
import f_profit2 from './financial/profit2.svg';
import f_orders2 from './financial/orders2.svg';
import f_profit_plus from './financial/profit_plus.svg';
import f_profit_minus from './financial/profit_minus.svg';
import f_companies from './financial/companies.svg';
import d_person from './defaults/person.svg';
import o_with_coupon from './others/with_coupon.svg';
import o_without_coupon from './others/without_coupon.svg';
import o_wameed_logo from './others/wameed_black.svg';
import o_order from './others/order.svg';
import o_copy from './others/copy.svg';
import o_toggle from './others/toggle.svg';
import o_show from './others/show.svg';
import o_hide from './others/hide.svg';

import o_sent from './others/sent.svg';
import o_roles from './others/roles.svg';
import o_import from './others/import.svg';
import o_export from './others/export.svg';
import o_plus from './others/plus.svg';
import o_warning from './others/warning.svg';
import o_warningDanger from './others/warning-danger.svg';
import o_minus from './others/minus.svg';
import nav_users from './nav/users.svg';
import nav_other from './nav/other.svg';
import nav_reports from './nav/reports.svg';
import nav_ads from './nav/ads.svg';
import nav_chat from './nav/chat.svg';
import chat_send from './chat/send.svg';

import s_filter_edit from './settings/filter_edit.svg';
import s_filter_delete from './settings/filter_delete.svg';

import addGray from './add-gray.svg';

// HALABK / IMPORTS - START
import tick from './tick.svg';
import trash from './trash.svg';
import falseCheck from './false-check.svg';
import trueCheck from './true-check.svg';
import filter from './filter.svg';
import logout2 from './logout2.svg';
import element from './element.svg';
import calender from './calendar.svg';
import calenderMain from './calendar-main.svg';
import coupons from './nav/coupons.svg';
import money from './nav/money.svg';
import statusUp from './nav/status-up.svg';
import messages from './messages.svg';
import home from './nav/home.svg';
import dash from './nav/dash.svg';
import orders from './nav/orders.svg';
import products from './nav/products.svg';
import categories from './nav/categories.svg';
import setting from './setting.svg';
import ticketDiscount from './ticket-discount.svg';
import star from './nav/star.svg';
import menu from './menu.svg';
import panel1 from './panel1.svg';
import panel2 from './panel2.svg';
import panel3 from './panel3.svg';
import panel4 from './panel4.svg';
import edit from './edit.svg';
import starFill from './star-fill.svg';
import locationFill from './location-fill.svg';
import addCircle from './add-circle.svg';
import addFilldCircle from './add-filled-circle.svg';
import verticalDots from './vertical-dots.svg';
import sortable from './sortable.svg';
import packages from './packages.svg';
import logo from './logo.svg';
import LogoImage from './logo-image.svg';
import lang from './lang.svg';
import email from './email.svg';
import lock from './lock.svg';
import arrowNextCircle from './arrow-next-circle.svg';
import cirlcePrev from './circle-prev.svg';
import stop from './stop.svg';
import chat2 from './chat2.svg';
import notification from './notification.svg';
import loginSvg1 from './login-svg-1.svg';
import loginSvg2 from './login-svg-2.svg';
import loginSvg3 from './login-svg-3.svg';
import imgClose from './img-close.svg';
import imgUpload from './img-upload.svg';
import fileUpload from './file-upload.svg';
import notification2 from './notification-icon.svg';
import warning from './warning.svg';
import bill2 from './bill2.svg';
import timer from './timer.svg';
import map from './map.svg';
import gps from './gps.svg';
import arrowCircleLeft2 from './arrow-circle-left.svg';
import crown from './crown.svg';
import forbidden from './forbidden.svg';
import tickCircle from './tick-circle.svg';
import story from './story.svg';
import danger from './danger.svg';
import tickSquire from './tick-square.svg';
import messageNotif from './message-notif.svg';
import closeHeader from './close-header-icon.svg';
import searchSM from './search-sm.svg';
import send3 from './send3.svg';
import alertWarning from './alert-warning.svg';
import block from './block.svg';
import ar from './ar.svg';
import en from './en.svg';
// HALABK / IMPORTS - END
import s_company from './settings/company.svg';
import s_gear from './settings/gear.svg';
import s_home from './settings/home.svg';
import s_date from './settings/date.svg';
import s_users from './settings/users.svg';
import s_wallet from './settings/wallet.svg';
import s_notifications from './settings/notifications.svg';
import s_payment from './settings/payment.svg';
import s_vehicles from './settings/vehicles.svg';
import s_app_messages from './settings/app_messages.svg';
import s_order_types from './settings/order_types.svg';
import s_classifications from './settings/classifications.svg';
import oBtnLeft from './others/btn-left.svg';

Vue.component('s-filter-delete-icon', s_filter_delete);
Vue.component('s-filter-edit-icon', s_filter_edit);
Vue.component('add-gray-icon', addGray);
Vue.component('s-company-icon', s_company);
Vue.component('s-app-messages-icon', s_app_messages);
Vue.component('s-classifications-icon', s_classifications);
Vue.component('s-home-icon', s_home);
Vue.component('s-gear-icon', s_gear);
Vue.component('s-date-icon', s_date);
Vue.component('s-wallet-icon', s_wallet);
Vue.component('s-notifications-icon', s_notifications);
Vue.component('s-payment-icon', s_payment);
Vue.component('s-vehicles-icon', s_vehicles);
Vue.component('s-order-types-icon', s_order_types);
Vue.component('s-users-icon', s_users);
Vue.component('chat-send-icon', chat_send);
Vue.component('nav-users-icon', nav_users);
Vue.component('nav-chat-icon', nav_chat);
Vue.component('nav-reports-icon', nav_reports);
Vue.component('nav-other-icon', nav_other);
Vue.component('nav-ads-icon', nav_ads);
Vue.component('o-roles-icon', o_roles);
Vue.component('o-import-icon', o_import);
Vue.component('o-export-icon', o_export);
Vue.component('o-plus-icon', o_plus);
Vue.component('o-minus-icon', o_minus);
Vue.component('o-sent-icon', o_sent);
Vue.component('o-show-icon', o_show);
Vue.component('o-warning-icon', o_warning);
Vue.component('o-warning-danger-icon', o_warningDanger);
Vue.component('o-hide-icon', o_hide);
Vue.component('o-toggle-icon', o_toggle);
Vue.component('o-copy-icon', o_copy);
Vue.component('o-order-icon', o_order);
Vue.component('o-with-coupon-icon', o_with_coupon);
Vue.component('o-wameed-icon', o_wameed_logo);
Vue.component('o-without-coupon-icon', o_without_coupon);
Vue.component('d-person-icon', d_person);
Vue.component('f-products-icon', f_products);
Vue.component('f-orders-icon', f_orders);
Vue.component('f-sales-icon', f_sales);
Vue.component('f-profit-icon', f_profit);
Vue.component('f-profit2-icon', f_profit2);
Vue.component('f-orders2-icon', f_orders2);
Vue.component('f-profit-plus-icon', f_profit_plus);
Vue.component('f-profit-minus-icon', f_profit_minus);
Vue.component('f-clients-icon', f_clients);
Vue.component('f-clients-2-icon', f_clients2);
Vue.component('f-companies-icon', f_companies);

// HALABK / ICON COMPONENTS - START
Vue.component('alert-warning-icon', alertWarning);
Vue.component('send3-icon', send3);
Vue.component('search-sm-icon', searchSM);
Vue.component('close-header-icon', closeHeader);
Vue.component('orders-icon', orders);
Vue.component('products-icon', products);
Vue.component('categories-icon', categories);
Vue.component('message-notif-icon', messageNotif);
Vue.component('story-icon', story);
Vue.component('danger-icon', danger);
Vue.component('tick-squire-icon', tickSquire);
Vue.component('tick-circle-icon', tickCircle);
Vue.component('forbidden-icon', forbidden);
Vue.component('crown-icon', crown);
Vue.component('arrow-circle-left-2-icon', arrowCircleLeft2);
Vue.component('gps-icon', gps);
Vue.component('map-address-icon', map);
Vue.component('timer-icon', timer);
Vue.component('bill2-icon', bill2);
Vue.component('chat2-icon', chat2);
Vue.component('tick-icon', tick);
Vue.component('add-filled-circle-icon', addFilldCircle);
Vue.component('trash-icon', trash);
Vue.component('true-check-icon', trueCheck);
Vue.component('false-check-icon', falseCheck);

Vue.component('edit-icon', edit);
Vue.component('add-circle-icon', addCircle);
Vue.component('location-fill-icon', locationFill);
Vue.component('star-fill-icon', starFill);
Vue.component('panel1-icon', panel1);
Vue.component('panel2-icon', panel2);
Vue.component('panel3-icon', panel3);
Vue.component('panel4-icon', panel4);
Vue.component('element-icon', element);
Vue.component('calender-icon', calender);
Vue.component('calender-main-icon', calenderMain);
Vue.component('money-icon', money);
Vue.component('coupons-icon', coupons);
Vue.component('star-icon', star);
Vue.component('ticket-discount-icon', ticketDiscount);
Vue.component('status-up-icon', statusUp);
Vue.component('messages-icon', messages);
Vue.component('home-icon', home);
Vue.component('dash-icon', dash);
Vue.component('setting-icon', setting);
Vue.component('menu-icon', menu);
Vue.component('logout2-icon', logout2);
Vue.component('filter-icon', filter);
Vue.component('vertical-dots-icon', verticalDots);
Vue.component('sortable-icon', sortable);
Vue.component('packages-icon', packages);
Vue.component('logo-light', logo);
Vue.component('logo-image-icon', LogoImage);
Vue.component('lang-icon', lang);
Vue.component('email-icon', email);
Vue.component('lock-icon', lock);
Vue.component('arrow-next-circle-icon', arrowNextCircle);
Vue.component('circle-prev-icon', cirlcePrev);
Vue.component('stop-icon', stop);
Vue.component('notification-icon', notification);
// HALABK / ICON COMPONENTS - END

Vue.component('arrow-down-icon', arrowDown);
Vue.component('bill-icon', bill);
Vue.component('chat-icon', chat);
Vue.component('check-icon', check);
Vue.component('close-icon', close);
Vue.component('emails-icon', emails);
Vue.component('applicants-icon', applicants);
Vue.component('eyeoff-icon', eyeoff);
Vue.component('eyeon-icon', eyeon);
Vue.component('logout-icon', logout);
Vue.component('moon-icon', moon);
Vue.component('nodata-icon', nodata);
Vue.component('search-icon', search);
Vue.component('trainging-icon', trainging);
Vue.component('logo-dark', logoDark);
Vue.component('users-icon', users);
Vue.component('skills-icon', skills);
Vue.component('bag-icon', bag);
Vue.component('jobs-bag-icon', jobsBag);
Vue.component('location-icon', location);
Vue.component('clock-icon', clock);
Vue.component('file-icon', file);
Vue.component('download-icon', download);
Vue.component('btn-arrow-left-icon', oBtnLeft);
Vue.component('arrow-prev-icon', arrowPrev);
Vue.component('arrow-next-icon', arrowNext);
Vue.component('company-icon', company);
Vue.component('government-icon', government);
Vue.component('individual-icon', individual);
Vue.component('organization-icon', organization);
Vue.component('login-svg1', loginSvg1);
Vue.component('login-svg2', loginSvg2);
Vue.component('login-svg3', loginSvg3);
Vue.component('img-close-icon', imgClose);
Vue.component('img-upload-icon', imgUpload);
Vue.component('file-upload-icon', fileUpload);
Vue.component('notification2-icon', notification2);
Vue.component('warning-icon', warning);
Vue.component('block-icon', block);
Vue.component('ar-icon', ar);
Vue.component('en-icon', en);
Vue.component('refresh-icon', refresh);
